var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6665 2.66699H26.6665C28.1332 2.66699 29.3332 3.86699 29.3332 5.33366V21.3337C29.3332 22.8003 28.1332 24.0003 26.6665 24.0003H10.6665C9.19984 24.0003 7.99984 22.8003 7.99984 21.3337V5.33366C7.99984 3.86699 9.19984 2.66699 10.6665 2.66699ZM2.6665 8.00033H5.33317V26.667H23.9998V29.3337H5.33317C3.8665 29.3337 2.6665 28.1337 2.6665 26.667V8.00033ZM26.6665 21.3337H10.6665V5.33366H26.6665V21.3337ZM19.9998 18.667H17.3332V14.667H13.3332V12.0003H17.3332V8.00033H19.9998V12.0003H23.9998V14.667H19.9998V18.667Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectIcon);
export default __webpack_public_path__ + "static/media/multiselect-icon.dfc1b5af.svg";
export { ForwardRef as ReactComponent };